import { render, staticRenderFns } from "./AccountIcon.vue?vue&type=template&id=2b5ce3b2&scoped=true&"
import script from "./AccountIcon.vue?vue&type=script&lang=js&"
export * from "./AccountIcon.vue?vue&type=script&lang=js&"
import style0 from "./AccountIcon.vue?vue&type=style&index=0&id=2b5ce3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5ce3b2",
  null
  
)

export default component.exports